/* Maison Ronron v13 bis « ultime » : page panier (préfixe pn).
   − / + / Retirer via /cart/change.js (clé de ligne), puis re-rendu de la section par l'API Section Rendering
   (?section_id=) : chiffres qui roulent, ligne retirée qui se replie, compteur de la barre relu par MR14.panier.lire().
   Sans JavaScript, le formulaire Shopify de la section fonctionne seul (updates[], url_to_remove, checkout). */
(function () {
  'use strict';

  const MR14 = window.MR14 = window.MR14 || {};
  const pret = MR14.pret || ((fn) => (document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn) : fn()));

  pret(() => {
    const racine = document.querySelector('[data-pn-racine]');
    if (!racine) return;
    const reduit = !!MR14.reduit || document.documentElement.classList.contains('reduit');
    const idSection = racine.dataset.sectionId;
    const base = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/?$/, '/');
    const URL_CHANGE = base + 'cart/change.js';
    const erreurEl = racine.querySelector('[data-pn-erreur]');
    const annonceEl = racine.querySelector('[data-pn-annonce]');
    const ERREUR = 'Impossible de mettre à jour le panier pour le moment. Réessayez dans un instant.';

    /* ---------- Sur cette page, le bouton panier de la barre ne rouvre pas le tiroir ---------- */
    const titre = racine.querySelector('#pn-titre');
    const btnNav = () => document.querySelector('[data-m-panier]');
    const marquerNav = () => { const b = btnNav(); if (b) b.setAttribute('aria-current', 'page'); };
    marquerNav();
    window.addEventListener('click', (e) => {
      const b = e.target.closest && e.target.closest('[data-m-panier]');
      if (!b) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      window.scrollTo({ top: 0, behavior: reduit ? 'auto' : 'smooth' });
      if (titre) titre.focus({ preventScroll: true });
    }, true);

    /* ---------- Outils ---------- */
    let tic = 0;
    const roule = (el, valeur, sens) => {
      if (!el) return;
      valeur = String(valeur);
      if (el.textContent === valeur) return;
      el.textContent = valeur;
      if (reduit) return;
      tic += 1;
      el.classList.remove('m-rh1', 'm-rh2', 'm-rb1', 'm-rb2');
      el.classList.add((sens < 0 ? 'm-rb' : 'm-rh') + (tic % 2 ? '1' : '2'));
    };
    const rebond = (el) => {
      if (reduit || !el || !el.animate) return;
      el.animate([{ transform: 'scale(1)' }, { transform: 'scale(.9, 1.08)', offset: 0.3 }, { transform: 'scale(1.06, .96)', offset: 0.62 }, { transform: 'scale(1)' }],
        { duration: 520, easing: 'cubic-bezier(.23,1,.32,1)' });
    };
    const annoncer = (t) => { if (!annonceEl) return; annonceEl.textContent = ''; setTimeout(() => { annonceEl.textContent = t; }, 40); };
    const montrerErreur = (t) => { if (erreurEl) { erreurEl.textContent = t || ERREUR; erreurEl.hidden = false; } };
    const cacherErreur = () => { if (erreurEl) { erreurEl.hidden = true; erreurEl.textContent = ''; } };
    const ligneDe = (key) => [...racine.querySelectorAll('[data-pn-ligne]')].find((l) => l.dataset.key === key) || null;

    /* ---------- Requêtes ---------- */
    const changer = (key, quantite) => fetch(URL_CHANGE, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: quantite }),
    }).then((r) => r.json().catch(() => ({})).then((d) => {
      if (!r.ok || (d && d.status && Number(d.status) >= 400)) throw new Error((d && (d.description || d.message)) || ERREUR);
      return d;
    }));

    const lireSection = () => fetch(location.pathname + '?section_id=' + encodeURIComponent(idSection), { credentials: 'same-origin' })
      .then((r) => { if (!r.ok) throw new Error(ERREUR); return r.text(); })
      .then((html) => new DOMParser().parseFromString(html, 'text/html').querySelector('[data-pn-racine]'));

    /* ---------- Application du nouveau rendu ---------- */
    const replier = (l) => new Promise((ok) => {
      if (reduit || !l.animate) { l.remove(); ok(); return; }
      const h = l.getBoundingClientRect().height;
      l.style.pointerEvents = 'none';
      const a = l.animate([
        { height: h + 'px', opacity: 1, transform: 'none', paddingTop: getComputedStyle(l).paddingTop, paddingBottom: getComputedStyle(l).paddingBottom },
        { height: h + 'px', opacity: 0, transform: 'translateX(-24px) scale(.98)', offset: 0.45 },
        { height: '0px', opacity: 0, transform: 'translateX(-24px) scale(.98)', paddingTop: '0px', paddingBottom: '0px', borderBottomWidth: '0px' },
      ], { duration: 620, easing: 'cubic-bezier(.23,1,.32,1)', fill: 'forwards' });
      a.onfinish = () => { l.remove(); ok(); };
      a.oncancel = () => { l.remove(); ok(); };
    });

    const remplacerCorps = (neuf) => {
      const corps = racine.querySelector('[data-pn-corps]');
      const nc = neuf.querySelector('[data-pn-corps]');
      if (!corps || !nc) return;
      const nouveau = document.importNode(nc, true);
      nouveau.querySelectorAll('.revele').forEach((e) => e.classList.add('vu'));
      corps.replaceWith(nouveau);
      if (!reduit && nouveau.animate) nouveau.animate([{ opacity: 0, transform: 'translateY(18px)' }, { opacity: 1, transform: 'none' }], { duration: 640, easing: 'cubic-bezier(.23,1,.32,1)' });
      brancher();
    };

    const appliquer = (neuf, sens) => {
      if (!neuf) return Promise.resolve();
      const meta = racine.querySelector('[data-pn-meta]');
      const nm = neuf.querySelector('[data-pn-meta]');
      if (meta && nm && meta.textContent !== nm.textContent) meta.textContent = nm.textContent;

      const formNeuf = neuf.querySelector('[data-pn-form]');
      const form = racine.querySelector('[data-pn-form]');
      if (!formNeuf || !form) {
        // panier devenu vide (ou rempli ailleurs) : on replie les lignes puis on remplace tout le corps
        const lignes = [...racine.querySelectorAll('[data-pn-ligne]')];
        return Promise.all(lignes.map(replier)).then(() => {
          remplacerCorps(neuf);
          const lien = racine.querySelector('.pn-vide-btn');
          if (titre) titre.focus({ preventScroll: true }); else if (lien) lien.focus({ preventScroll: true });
        });
      }

      const cles = new Set([...formNeuf.querySelectorAll('[data-pn-ligne]')].map((l) => l.dataset.key));
      const actuelles = [...form.querySelectorAll('[data-pn-ligne]')];
      const restantes = actuelles.filter((l) => cles.has(l.dataset.key));
      const anciennesCles = new Set(actuelles.map((l) => l.dataset.key));
      const nouvellesLignes = [...formNeuf.querySelectorAll('[data-pn-ligne]')].some((l) => !anciennesCles.has(l.dataset.key));
      if (nouvellesLignes) { remplacerCorps(neuf); return Promise.resolve(); }

      // focus : si une ligne disparaît alors qu'elle contient le focus, on le donne à la ligne suivante ou au titre
      const parties = actuelles.filter((l) => !cles.has(l.dataset.key));
      parties.forEach((l) => {
        if (!l.contains(document.activeElement)) return;
        const i = actuelles.indexOf(l);
        const suivante = actuelles.slice(i + 1).concat(actuelles.slice(0, i).reverse()).find((x) => cles.has(x.dataset.key));
        const cible = suivante ? suivante.querySelector('[data-pn-pas]') : titre;
        if (cible) cible.focus({ preventScroll: true });
      });

      restantes.forEach((l) => {
        const n = [...formNeuf.querySelectorAll('[data-pn-ligne]')].find((x) => x.dataset.key === l.dataset.key);
        const q = n.querySelector('[data-pn-n]').textContent;
        const qEl = l.querySelector('[data-pn-n]');
        const s = sens || (Number(q) >= Number(qEl.textContent) ? 1 : -1);
        roule(qEl, q, s);
        const champ = l.querySelector('[data-pn-champ]');
        if (champ) champ.value = n.querySelector('[data-pn-champ]').value;
        roule(l.querySelector('[data-pn-prix]'), n.querySelector('[data-pn-prix]').textContent, s);
        const moinsN = n.querySelector('[data-pn-pas="-1"]');
        const moins = l.querySelector('[data-pn-pas="-1"]');
        if (moins && moinsN) moins.setAttribute('aria-label', moinsN.getAttribute('aria-label'));
        const pu = l.querySelector('.pn-pu'); const puN = n.querySelector('.pn-pu');
        if (pu && puN && pu.textContent !== puN.textContent) pu.textContent = puN.textContent;
      });

      ['sous', 'total'].forEach((k) => {
        const a = form.querySelector(`[data-pn-val="${k}"]`);
        const b = formNeuf.querySelector(`[data-pn-val="${k}"]`);
        if (!a || !b) return;
        const s = sens || (Number(b.dataset.pnCents) >= Number(a.dataset.pnCents) ? 1 : -1);
        a.dataset.pnCents = b.dataset.pnCents;
        roule(a, b.textContent, s);
      });
      const rem = form.querySelector('[data-pn-remises]');
      const remN = formNeuf.querySelector('[data-pn-remises]');
      if (rem && remN) rem.replaceChildren(...[...remN.childNodes].map((x) => document.importNode(x, true)));

      return Promise.all(parties.map(replier));
    };

    /* ---------- File des changements : l'ordre des clics est gardé, un seul re-rendu à la fin ---------- */
    const voulu = {};
    let file = Promise.resolve();
    let attente = 0;
    let dernierSens = 1;

    const demander = (key, quantite, sens) => {
      voulu[key] = quantite;
      dernierSens = sens;
      attente += 1;
      cacherErreur();
      const form = racine.querySelector('[data-pn-form]');
      if (form) form.setAttribute('aria-busy', 'true');
      let rate = null;
      file = file
        .then(() => changer(key, quantite))
        .catch((err) => { rate = err; })
        .then(() => {
          attente -= 1;
          if (rate) montrerErreur(rate.message);
          if (attente > 0) return null;
          return lireSection()
            .then((neuf) => appliquer(neuf, rate ? 0 : dernierSens).then(() => neuf))
            .then((neuf) => {
              Object.keys(voulu).forEach((k) => delete voulu[k]);
              const f = racine.querySelector('[data-pn-form]');
              if (f) f.removeAttribute('aria-busy');
              if (!rate && neuf) {
                const tot = neuf.querySelector('[data-pn-val="total"]');
                const nb = neuf.querySelectorAll('[data-pn-ligne]').length;
                annoncer(nb ? `Panier mis à jour. Total : ${tot ? tot.textContent.trim() : ''}.` : 'Votre panier est vide.');
              }
              if (MR14.panier && typeof MR14.panier.lire === 'function') return MR14.panier.lire().catch(() => {});
              return null;
            })
            .catch(() => {
              // re-rendu impossible : on recharge la page (le panier côté Shopify est déjà à jour)
              location.reload();
            });
        });
    };

    function brancher() {
      const form = racine.querySelector('[data-pn-form]');
      if (!form || form.dataset.pnBranche) return;
      form.dataset.pnBranche = '1';
      form.addEventListener('click', (e) => {
        const pas = e.target.closest('[data-pn-pas]');
        const retirer = e.target.closest('[data-pn-retirer]');
        if (!pas && !retirer) return;
        const l = e.target.closest('[data-pn-ligne]');
        if (!l) return;
        e.preventDefault();
        const key = l.dataset.key;
        const qEl = l.querySelector('[data-pn-n]');
        const actuelle = key in voulu ? voulu[key] : Number(qEl.textContent) || 0;
        const d = retirer ? -actuelle : Number(pas.dataset.pnPas);
        const q = Math.max(0, actuelle + d);
        if (q === actuelle) return;
        if (q > 0) {
          roule(qEl, q, d);
          rebond(l.querySelector('.pn-qte'));
          const champ = l.querySelector('[data-pn-champ]');
          if (champ) champ.value = q;
        } else {
          l.style.transition = 'opacity 260ms ease';
          l.style.opacity = '.45';
        }
        demander(key, q, d < 0 ? -1 : 1);
      });
      // champ de quantité tapé à la main (lecteurs d'écran qui le trouvent malgré tout)
      form.addEventListener('change', (e) => {
        const c = e.target.closest('[data-pn-champ]');
        if (!c) return;
        const l = c.closest('[data-pn-ligne]');
        const q = Math.max(0, parseInt(c.value, 10) || 0);
        demander(l.dataset.key, q, 1);
      });
    }
    brancher();

    // Retour par l'historique (page en cache) : on relit la section
    addEventListener('pageshow', (e) => {
      if (!e.persisted) return;
      lireSection().then((neuf) => { if (neuf) remplacerCorps(neuf); }).catch(() => {});
    });
  });
})();
